<template>
  <div class="BlockList" v-show="floag">
    <div class="BlockList-W">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close1"
      />
      <div class="bindbox">
        <div class="bindcons">
          Confirm to log out of the current<br />
          account
        </div>
        <div class="bindbtn">
          <div class="botton" @click="close1">close</div>
          <div class="botton1" @click="Confirms">Confirm</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetLogin } from "@/assets/server/api";
import { getSubStr } from "@/utils/utils";
export default {
  props: ["lflog"],
  data() {
    return {
      floag: false,
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    deep: true,
    lflog(val) {
      this.floag = val;
    },
  },
  methods: {
    close1() {
      this.floag = false;
      this.$emit("logouts", this.floag);
    },
    Confirms() {
      localStorage.removeItem("userId");
      localStorage.removeItem("email");

      // localStorage.removeItem("isBindAddress");
      this.$emit("email", "");
      this.floag = false;
      this.$emit("logouts", this.floag);
      this.$emit("loginflog", true);
      this.$message({
        message: "Logout successful",
        type: "warning",
        customClass: "message-zindex",
      });
      window.location.reload();
      //@loginflog="loginflog($event)"
      // this.$emit("isBind", "");
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 650px;
    height: 356px;
    background: #202020;
    border-radius: 20px 20px 20px 20px;
    position: absolute;
    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .imgs {
      width: 36px;
      height: 36px;
      margin-left: 580px;
      margin-top: 12px;
    }
    .bindbox {
      width: 530px;
      margin: 0 auto;

      .bindcons {
        margin-top: 10px;
        height: 84px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
      }
      .bindbtn {
        display: flex;
        margin-top: 60px;
        .botton {
          width: 250px;
          height: 76px;
          line-height: 76px;
          border-radius: 162px 162px 162px 162px;
          border: 2px solid #3cf6f0;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 30px;
          color: #3cf6f0;
          cursor: pointer;
        }
        .botton1 {
          width: 252px;
          height: 76px;
          background: #3cf6f0;
          border-radius: 162px 162px 162px 162px;
          line-height: 76px;
          text-align: center;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 30px;
          color: #151515;
          margin-left: 28px;
        }
      }
    }
  }
}
</style>
